import Vue from "vue";

const truncate = (text, limit) => {
  return text.length > limit ? `${text.substring(0, limit)}...` : text
}

const colon = text => `${text}:`

Vue.filter('truncate', truncate)
Vue.filter('colon', colon)

